/* eslint-disable no-console */
import isObject from 'is-object';
import { getReference, getMarket } from '@atc/bonnet-reference';
import constants from './constants';
import normalizeSeoValue from './normalizeSeoValue';
export const isStringCheck = (value, _ref) => {
  let {
    param
  } = _ref;
  if (typeof value !== 'string') {
    throw new Error(`${param} must be a string in order to be encoded.  Received ${typeof value}`);
  }
};
export const getNameFromReferenceData = async (value, _ref2) => {
  let {
    param,
    ...rest
  } = _ref2;
  const {
    payload = {}
  } = await getReference(param, rest);
  let name = '';
  const normalizedValue = normalizeSeoValue(value);

  // retrieve the name of the value by matching the code of the value to the reference data
  const data = payload.find(_ref3 => {
    let {
      code
    } = _ref3;
    return normalizeSeoValue(code) === normalizedValue;
  });
  if (data) {
    ({
      name
    } = data);
  }
  return name;
};
export default async function encode(value) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    param
    // brand = 'atc',
  } = options;
  let encodedValue = '';
  // Don't strip these characters. Add additional characters as needed
  const allowedCharacters = ['-', '+', '_', ' '];
  switch (param) {
    case 'trimCode':
      {
        isStringCheck(value, options);
        // strip model code off by first occurrence of pipe delimiter
        [, encodedValue] = value.split(/\|(.*)/s);
        // account for Kia Soul !
        if (encodedValue === '!') {
          allowedCharacters.push('!');
        }
        if (!encodedValue) {
          encodedValue = value;
        }
        break;
      }
    case 'dealerName':
      {
        isStringCheck(value, options);
        encodedValue = value;
        break;
      }
    case 'location':
      {
        if (!isObject(value)) {
          throw Error('location seo encoder must be provided an object containing a city, state, and zip');
        }

        // eslint-disable-next-line prefer-const
        let {
          city,
          state,
          zip
        } = value;

        // handle hydrating city, state when only zip is provided
        if (!city && !state) {
          try {
            const {
              success,
              payload: location
            } = await getMarket(zip);
            if (success) {
              ({
                city,
                state
              } = location);
            }
          } catch (err) {
            console.error('Unable to prepare location data for the seoLocation.  Ensure you are passing a location object.');
            throw err;
          }
        }

        // If we have a city and state then process with encoding.
        if (city && state) {
          encodedValue = `${city} ${state}`;
        }
        break;
      }
    case 'price':
      {
        if (!isObject(value)) {
          throw Error('price seo encoder must be provided an object containing a minPrice and maxPrice');
        }
        const {
          minPrice,
          maxPrice
        } = value;
        let values = [];
        if (minPrice > 0 && !maxPrice) {
          values = [constants.CARS, constants.OVER, minPrice];
        } else if ((!minPrice || minPrice === 0) && maxPrice > 0) {
          values = [constants.CARS, constants.UNDER, maxPrice];
        } else {
          values = [constants.CARS, constants.RANGE, minPrice, constants.CONNECTOR, maxPrice];
        }
        encodedValue = values.join(' ');
        break;
      }
    case 'sellerType':
      {
        isStringCheck(value, options);
        switch (value) {
          case 'p':
            encodedValue = 'by-owner';
            break;
          case 'd':
            encodedValue = 'dealer';
            break;
          default:
        }
        break;
      }
    case 'year':
      {
        const {
          startYear,
          endYear
        } = value;
        if (endYear === startYear) {
          encodedValue = String(startYear);
        }
        break;
      }
    default:
      {
        try {
          encodedValue = await getNameFromReferenceData(value, options);
        } catch (err) {
          // If we have no reference data available for some reason then we
          // just try a brute force encodding of the value
          // seo encode the value and add it to the query as an `seo` slug
          encodedValue = value;
        }
      }
  }
  const stripRegex = new RegExp(`[^a-zA-Z0-9${allowedCharacters.join('')}]`, 'gi');
  return encodedValue
  // replace any %20 with a space
  .replace(/%20/gi, ' ')
  // replace any /, \, or . with a space
  .replace(/[/\\.]/gi, ' ')
  // strip any character that is not
  // a letter or number, dash, underscore, or space
  .replace(stripRegex, '')
  // trim any whitespace
  .trim()
  // replace all spaces (multiple as well) with a single plus
  .replace(/ +/g, '-')
  // replace multiple minus sign with a single one
  .replace(/-+/g, '-').toLowerCase();
}